/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How FUEL entry fee amount is determined
 * @export
 */
export const FuelPricingMode = {
    QTY: 'QTY',
    USD_EQUIVALENT: 'USD_EQUIVALENT'
} as const;
export type FuelPricingMode = typeof FuelPricingMode[keyof typeof FuelPricingMode];


export function instanceOfFuelPricingMode(value: any): boolean {
    for (const key in FuelPricingMode) {
        if (Object.prototype.hasOwnProperty.call(FuelPricingMode, key)) {
            if (FuelPricingMode[key as keyof typeof FuelPricingMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FuelPricingModeFromJSON(json: any): FuelPricingMode {
    return FuelPricingModeFromJSONTyped(json, false);
}

export function FuelPricingModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelPricingMode {
    return json as FuelPricingMode;
}

export function FuelPricingModeToJSON(value?: FuelPricingMode | null): any {
    return value as any;
}

export function FuelPricingModeToJSONTyped(value: any, ignoreDiscriminator: boolean): FuelPricingMode {
    return value as FuelPricingMode;
}

